import PropTypes from 'prop-types';

// Inline single-path glyph (not an asset import) so it ships in the bundle with
// no extra request and inherits the CTA text color via `fill: currentcolor`.
export default function PlayIcon({ className = '' }) {
  return (
    <svg
      className={className}
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M0 1.4v13.2a1 1 0 0 0 1.53.85l10.6-6.6a1 1 0 0 0 0-1.7L1.53.55A1 1 0 0 0 0 1.4Z" />
    </svg>
  );
}

PlayIcon.propTypes = {
  className: PropTypes.string,
};
